import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {HomepageMock, PddHomepageMock} from './mock'
import {PopUpTypeEnum} from './constant'

export const getHomepage = createAsyncThunk(
  'getHomepage',
  async (_, store: any) => {
    // return HomepageMock
    const resp = await http.post(
      '/live/activity/anniversary_config_2025',
      {},
      {
        store: window.store,
      }
    )
    return resp.data?.data
  }
)

export const getPddHomepage = createAsyncThunk(
  'getPddHomepage',
  async (_, store: any) => {
    // return PddHomepageMock
    const resp = await http.post(
      '/live/activity/anniversary_pdd_v2_homepage',
      {},
      {
        store: window.store,
      }
    )
    return resp.data?.data
  }
)

const initialState: {
  homepage?: {
    peak_race_countdown?: number
    pdd_countdown?: number
    activity_status?: number
    is_day_first?: boolean
    big_pool?: number
    big_rewards?: {
      name: string
      icon: string
      has_show_effect: boolean
      id: number
    }[]
    activities?: {
      id: number
      title: string
      icon: string
      start_time: string
      end_time: string
      link: string
      status: number
      unread: boolean
      rewards: {
        name?: string
        icon?: string
        has_show_effect: boolean
        id: number
      }[]
    }[]
  }
  pddHomepage?: {
    is_first_pop?: string
    count_down?: 82966
    daily_reward?: {
      tag: string
      name: string
      icon: string
      type: number
      coins: number
    }
    notice?: {
      goods_name: string
      name: string
      avatar: string
      coins: string
    }[]
    follower_list?: {
      member: {
        name: string
        mid: number
        zy_id: string
        avatar: string
        charm_level: {
          id: number
          icon: string
        }
        wealth_level: {
          id: number
          icon: string
        }
        gender: number
        flag: null
      }
      status: number
    }[]
    followee_list?: {
      member: {
        name: string
        mid: number
        zy_id: string
        avatar: string
        charm_level: {
          id: number
          icon: string
        }
        wealth_level: {
          id: number
          icon: string
        }
        gender: number
        flag: null
      }
      status: number
    }[]
    assist_records?: {
      member: {
        name: string
        mid: number
        zy_id: string
        avatar: string
        charm_level: {
          id: number
          icon: string
        }
        wealth_level: {
          id: number
          icon: string
        }
        gender: number
        flag: null
      }
      assist_time: string
    }[]
    remain_assisted_num?: number
    assisted_num?: number
    assisted_max?: number
    assist_others_num?: number
    assist_others_max?: number
    exchange_status?: number
  }
  popupVisible?: PopUpTypeEnum | null
  videoPlaying?: boolean | null
} = {
  homepage: {},
  pddHomepage: {},
  popupVisible: null,
  videoPlaying: null,
}

export const AnnualHomepage2025Slice = createSlice({
  name: 'AnnualHomepage2025',
  initialState,
  reducers: {
    setPopupVisible: (state, action) => {
      Object.assign(state, {
        popupVisible: action.payload,
      })
    },
    setVideoPlaying: (state, action) => {
      Object.assign(state, {
        videoPlaying: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getHomepage.fulfilled, (state, action) => {
      Object.assign(state?.homepage, action.payload)
    })
    builder.addCase(getPddHomepage.fulfilled, (state, action) => {
      Object.assign(state?.pddHomepage, action.payload)
    })
  },
})

export default AnnualHomepage2025Slice.reducer
export const AnnualHomepage2025Actions = AnnualHomepage2025Slice.actions
